'use client';

import { ErrorSection } from '@pickleballinc/react-ui';
import { useSession } from '@pickleballinc/ui/components/global/SessionProvider';

import { usePlayerClubs } from '@/hooks/players/useGetPlayerClubs';
import { FilterTabs } from '@/modules/players/v2/navigation/FilterTabs';
import { EventCardsListSkeleton } from '@/modules/players/v2/navigation/skeletons/EventCardsListSkeleton';
import { ClubsWrapper } from '@/modules/players/v2/tabs/clubs/ClubsWrapper';
import { ClubTypes } from '@/types/clubs.types';
import { PlayerData } from '@/types/players.types';
import { SearchParams } from '@/types/types';

interface ClubsClientWrapperProps {
  player: PlayerData;
  activeClubType: ClubTypes;
  page: string;
  queryParams?: SearchParams;
}

export const ClubsClientWrapper = ({
  player,
  activeClubType,
  page,
  queryParams,
}: ClubsClientWrapperProps) => {
  const { session } = useSession();
  const isFavorites = activeClubType === ClubTypes.Favorites;

  const {
    data: clubsResult,
    isLoading,
    isFetching,
  } = usePlayerClubs({
    playerId: player.uuid,
    activeClubType,
    page,
    queryParams,
  });

  if (!isLoading && clubsResult?.error) {
    return (
      <ErrorSection
        Subheading='Please reach out to our support to report this issue'
        heading='Something wrong happened'
      />
    );
  }

  const hasClubs = clubsResult ? clubsResult.totalRecords > 0 : false;

  return (
    <>
      <FilterTabs hasData={hasClubs} type='club' />

      <div className='container mx-auto mb-8 !max-w-[996px] rounded-md xl:!px-0'>
        {isLoading || isFetching ? (
          <EventCardsListSkeleton />
        ) : (
          <ClubsWrapper
            clubs={clubsResult?.clubs}
            player={player}
            user={session?.user}
            totalRecords={clubsResult?.totalRecords ?? 0}
            isFavoritesTab={isFavorites}
          />
        )}
      </div>
    </>
  );
};
